import IMAGES from "../../const/Image";
const NoPermission = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="n-per" style={{width:"50%"}}>
        <img src={IMAGES.NoPermission} />
        <h1>You do not have permission to Access.</h1>
      </div>
    </div>
  );
};

export default NoPermission;
